import angular from 'angular';
import MessageDetailsComponent from './message-details-component';

export default angular.module('message-details', []).component('messageDetails', new MessageDetailsComponent());



// WEBPACK FOOTER //
// ./src/modules/message/components/message-details/message-details-module.js